import React from 'react';
import "../styles/about.css";
import Transition from '../components/Transition.js';

/*
  Replace these with local images in src/images/ when ready,
  e.g. import introImage from '../images/about-intro.jpg';
  All URLs below are free-license Unsplash photos.
*/
const IMG = {
  intro: "https://images.unsplash.com/photo-1547471080-7cc2caa01a7e?auto=format&fit=crop&w=1000&q=80",
  zambia: "https://images.unsplash.com/photo-1535941339077-2dd1c7963098?auto=format&fit=crop&w=800&q=80",
  zimbabwe: "https://images.unsplash.com/photo-1547721064-da6cfb341d50?auto=format&fit=crop&w=800&q=80",
  botswana: "https://images.unsplash.com/photo-1546182990-dffeafbe841d?auto=format&fit=crop&w=800&q=80",
  vicfalls: "https://images.unsplash.com/photo-1523805009345-7448845a9e53?auto=format&fit=crop&w=800&q=80",
};

const services = [
  { title: "Tailor-Made Itineraries", text: "Safari & leisure journeys designed entirely around you." },
  { title: "Group & Independent Travel", text: "Group tours and independent travel packages for every style." },
  { title: "Cross-Border Adventures", text: "Seamless multi-country journeys across Southern Africa." },
  { title: "Corporate & Incentive Travel", text: "Memorable retreats and reward trips that inspire teams." },
  { title: "Destination Management", text: "On-the-ground expertise for our travel partners." },
];

const destinations = [
  { img: IMG.zambia, country: "Zambia", places: "South Luangwa · Lower Zambezi · Kafue" },
  { img: IMG.zimbabwe, country: "Zimbabwe", places: "Hwange · Mana Pools · Nyanga" },
  { img: IMG.botswana, country: "Botswana", places: "Chobe" },
  { img: IMG.vicfalls, country: "Zimbabwe & Zambia", places: "Victoria Falls · Kariba" },
];

function About() {
  return (
    <div className="about">

      {/* Hero — same pattern as home hero */}
      <section className="hero">
        <div className="contentContainer">
          <div className="textContainer">
            <h1>About Duiker Travels</h1>
            <h3>Every journey is more than a trip — it's an experience you'll carry with you forever.</h3>
          </div>
        </div>
      </section>

      {/* Who we are */}
      <section className="who-we-are">
        <h2>Rooted in Southern Africa, Connected to the World</h2>

        <div className="content-container">
          <div className="text-container">
            <p>
              We are a specialist travel company with a deep love for Southern Africa,
              crafting personalised safari and leisure journeys across Zimbabwe, Zambia,
              and beyond. With roots in Southern Africa and connections across the globe,
              we bring together local expertise and international standards to create
              travel that feels both seamless and truly authentic.
            </p>
            <p>
              Whether you're dreaming of your first safari, planning a romantic escape,
              or seeking an unforgettable family adventure, we're here to bring that
              vision to life — tailored entirely around you.
            </p>
          </div>
          <div className="image-container">
            <img className="image" src={IMG.intro} alt="Elephant on the African savanna" />
          </div>
        </div>
      </section>

      {/* What we can plan — yellow section, white cards (like our-services on home) */}
      <section className="what-we-plan">
        <h2>What We Can Plan For You</h2>

        <div className="content-container">
          {services.map((s) => (
            <div className="item-container" key={s.title}>
              <h3>{s.title}</h3>
              <p>{s.text}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Destinations — blue-dark section, glass cards (like top-rated-destinations) */}
      <section className="destinations">
        <h2>Places We'll Take You</h2>

        <div className="content-container">
          {destinations.map((d) => (
            <div className="item-container" key={d.country + d.places}>
              <div className="image-container">
                <img className="image" src={d.img} alt={d.country} />
              </div>
              <h3>{d.country}</h3>
              <p>{d.places}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Beyond Africa */}
      <section className="beyond-africa">
        <h2>Exploring Beyond Africa</h2>
        <p>
          We also love helping African travellers discover the beauty of Europe —
          from the elegance of London to the timeless charm of the South of France.
          Travel is a two-way story, and we're proud to tell it in both directions.
        </p>
      </section>

      {/* Why travel with us */}
      <section className="why-us">
        <h2>Why Travel With Us?</h2>
        <p>
          Because we don't just book holidays — we design journeys. With local expertise,
          heartfelt service, and a genuine passion for connecting people with places,
          Duiker Travels is your trusted partner from the moment you start dreaming to
          the moment you return home.
        </p>
        <h3>Your African adventure — and beyond — starts here.</h3>
        <a href="/#contact">
          <button className="button">Start Planning</button>
        </a>
      </section>

    </div>
  );
}

export default Transition(About);